

<div *ngIf="order" class="automation-order-details-wrapper">
  <div class="details-header-card">
    <div class="header-main">
      <div class="header-patient">
        <h2>
          {{
            order.patient?.patient_name ||
              order.patient?.last_name + ', ' + order.patient?.first_name ||
              'N/A'
          }}
        </h2>
        <div class="header-provider" *ngIf="order.provider?.name">
          <span>{{ order.provider.name }}</span>
        </div>
        <div class="header-facility" *ngIf="order.order_facility">
          <span>{{ order.order_facility }}</span>
        </div>
      </div>
      <div class="header-mrn">
        <span class="mrn-label">MRN:</span>
        <span class="mrn-value">{{ order.patient?.med_rec_nbr || 'N/A' }}</span>
      </div>
    </div>
  </div>

  <div class="details-sections-grid">
    <!-- Order Details Card -->
    <div class="details-card"
      *ngIf="(parsedOrderDescription?.order?.description || parsedOrderDescription?.order?.side || parsedOrderDescription?.order?.site || parsedOrderDescription?.diagnosis || order?.ai_order_data?.order_cpt_code || order?.ai_order_data?.order_icd9 || order?.ai_order_data?.order_description)">
      <div class="card-title">
        <span class="icon-order"></span> Order Details
      </div>
      <div class="card-content">
        <ng-container *ngIf="parsedOrderDescription; else rawDesc">
          <div *ngIf="parsedOrderDescription.order">
            <div class="field-row" *ngIf="parsedOrderDescription.order.description">
              <span class="field-label">Text:</span>
              <span class="field-value">{{ parsedOrderDescription.order.description }}</span>
            </div>
            <div class="field-row" *ngIf="parsedOrderDescription.order.side">
              <span class="field-label">Side:</span>
              <span class="field-value">{{ parsedOrderDescription.order.side }}</span>
            </div>
            <div class="field-row" *ngIf="parsedOrderDescription.order.site">
              <span class="field-label">Site:</span>
              <span class="field-value">{{ parsedOrderDescription.order.site }}</span>
            </div>
          </div>
          <div *ngIf="parsedOrderDescription.diagnosis">
            <div class="field-row" *ngIf="parsedOrderDescription.diagnosis">
              <span class="field-label">Diagnosis:</span>
              <span class="field-value">{{ parsedOrderDescription.diagnosis }}</span>
            </div>
          </div>
          <div *ngIf="order.ai_order_data?.order_cpt_code">
            <div class="field-row" *ngIf="order.ai_order_data?.order_cpt_code">
              <span class="field-label">CPT:</span>
              <span class="field-value">{{ order.ai_order_data?.order_cpt_code }}</span>
            </div>
          </div>
          <div *ngIf="order.ai_order_data?.order_icd9">
            <div class="field-row" *ngIf="order.ai_order_data?.order_icd9">
              <span class="field-label">ICD9:</span>
              <span class="field-value">{{ order.ai_order_data?.order_icd9 }}</span>
            </div>
          </div>
        </ng-container>
        <ng-template #rawDesc>
          <div class="field-row" *ngIf="order.ai_order_data?.order_description">
            <span class="field-label">Order Description:</span>
            <span class="field-value">{{ order.ai_order_data?.order_description }}</span>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Combined Auth & Insurance Card -->
    <div class="details-card"
      [ngClass]="{
        'approved-card': order?.ai_order_portal_data?.status && order?.ai_order_portal_data?.status.toLowerCase() === 'approved',
        'warning-card': order?.ai_order_portal_data?.status && order?.ai_order_portal_data?.status.toLowerCase() !== 'approved'
      }"
      *ngIf="order?.ai_order_portal_data?.status || order?.ai_order_portal_data?.auth_number || order?.ai_order_portal_data?.tracking_id || order?.ai_order_portal_data?.validity_start_date || order?.ai_order_portal_data?.validity_end_date || order?.ai_order_insurance?.insurance_plan || order?.ai_order_insurance?.member_id">
      <div class="card-content">
        <!-- Auth Details Section (if any) -->
        <ng-container *ngIf="order?.ai_order_portal_data?.status || order?.ai_order_portal_data?.auth_number || order?.ai_order_portal_data?.tracking_id || order?.ai_order_portal_data?.validity_start_date || order?.ai_order_portal_data?.validity_end_date">
          <div class="card-title">
            <span class="icon-auth"></span> Auth Details
          </div>
          <ng-container *ngIf="order.ai_order_portal_data">
            <div *ngIf="order.ai_order_portal_data">
              <div class="field-row" *ngIf="order.ai_order_portal_data.status">
                <span class="field-label">Status:</span>
                <span class="field-value">{{ order.ai_order_portal_data.status }}</span>
              </div>
              <div class="field-row" *ngIf="order.ai_order_portal_data.auth_number">
                <span class="field-label">Auth Number:</span>
                <span class="field-value">{{ order.ai_order_portal_data.auth_number }}</span>
              </div>
              <div class="field-row" *ngIf="order.ai_order_portal_data.tracking_id">
                <span class="field-label">Tracking ID:</span>
                <span class="field-value">{{ order.ai_order_portal_data.tracking_id }}</span>
              </div>
            </div>
            <div *ngIf="order.ai_order_portal_data.validity_start_date">
              <div class="field-row">
                <span class="field-label">Validity Start Date:</span>
                <span class="field-value">{{ order.ai_order_portal_data.validity_start_date }}</span>
              </div>
            </div>
            <div *ngIf="order.ai_order_portal_data.validity_end_date">
              <div class="field-row">
                <span class="field-label">Validity End Date:</span>
                <span class="field-value">{{ order.ai_order_portal_data.validity_end_date }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Insurance Details Section (if any) -->
        <ng-container *ngIf="order?.ai_order_insurance?.insurance_plan || order?.ai_order_insurance?.member_id">
          <div class="card-title">
            <span class="icon-insurance"></span> Insurance Details
          </div>
          <ng-container *ngIf="order.order_facility">
            <div *ngIf="order.ai_order_insurance">
              <div class="field-row" *ngIf="order.ai_order_insurance?.insurance_plan">
                <span class="field-label">Insurance:</span>
                <span class="field-value">{{ order.ai_order_insurance?.insurance_plan }}</span>
              </div>
              <div class="field-row" *ngIf="order.ai_order_insurance?.member_id">
                <span class="field-label">Member ID:</span>
                <span class="field-value">{{ order.ai_order_insurance?.member_id }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Error Section Card -->
    <div class="details-card error-card" *ngIf="order.ai_portal_process_error || order.ai_ehr_process_error">
      <div class="card-title">
        <span class="icon-error"></span> Error
      </div>
      <div class="card-content">
        <div class="error-text">
          {{ order.ai_portal_process_error ? order.ai_portal_process_error : order.ai_ehr_process_error }}
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!order">
    <p>No order selected.</p>
</div>
